function SmallPostCardIcon() {
    return (
        <svg
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            width="35"
            height="35"
            viewBox="0 0 18.07 12.57">
            <g>
                <path
                    fill="#ffffff"
                    d="M2.05,16.14a.94.94,0,0,1-.93-.93V4.8a.94.94,0,0,1,.93-.94H18a.94.94,0,0,1,.93.94V15.2a.94.94,0,0,1-.93.94Zm0-11.6a.25.25,0,0,0-.26.26V15.2a.25.25,0,0,0,.26.26H18a.25.25,0,0,0,.26-.26V4.8A.25.25,0,0,0,18,4.54Z"
                    transform="translate(-0.96 -3.71)"
                />
                <path
                    fill="#ffffff"
                    d="M18,4a.78.78,0,0,1,.78.78V15.2A.78.78,0,0,1,18,16H2.05a.78.78,0,0,1-.78-.78V4.8A.78.78,0,0,1,2.05,4H18M2.05,15.62H18a.41.41,0,0,0,.41-.42V4.8A.41.41,0,0,0,18,4.38H2.05a.41.41,0,0,0-.41.42V15.2a.41.41,0,0,0,.41.42M18,3.71H2.05A1.1,1.1,0,0,0,1,4.79V15.2a1.1,1.1,0,0,0,1.09,1.09H18A1.1,1.1,0,0,0,19,15.21V4.8A1.1,1.1,0,0,0,18,3.71ZM2.05,15.31a.11.11,0,0,1-.11-.11V4.8a.11.11,0,0,1,.11-.11H18a.11.11,0,0,1,.11.11V15.2a.11.11,0,0,1-.11.11Z"
                    transform="translate(-0.96 -3.71)"
                />
            </g>
            <path
                fill="#ffffff"
                d="M10,14.22a.13.13,0,0,1-.13-.13V5.92a.13.13,0,0,1,.26,0v8.17A.13.13,0,0,1,10,14.22Z"
                transform="translate(-0.96 -3.71)"
            />
            <rect
                fill="#ffffff"
                x="13.98"
                y="1.73"
                width="2.1"
                height="2.29"
                rx="0.39"
            />
            <path
                fill="#ffffff"
                d="M16.89,10.25h-5.2a.13.13,0,0,1-.13-.14.13.13,0,0,1,.13-.13h5.2a.13.13,0,0,1,.13.13A.13.13,0,0,1,16.89,10.25Z"
                transform="translate(-0.96 -3.71)"
            />
            <path
                fill="#ffffff"
                d="M16.89,11.4h-5.2a.13.13,0,0,1-.13-.13.12.12,0,0,1,.13-.13h5.2a.13.13,0,0,1,.13.13A.13.13,0,0,1,16.89,11.4Z"
                transform="translate(-0.96 -3.71)"
            />
            <path
                fill="#ffffff"
                d="M16.89,12.51h-5.2a.13.13,0,0,1,0-.26h5.2a.13.13,0,1,1,0,.26Z"
                transform="translate(-0.96 -3.71)"
            />
            <path
                fill="#ffffff"
                d="M8.32,6.69H3.11a.13.13,0,0,1,0-.26H8.32a.13.13,0,1,1,0,.26Z"
                transform="translate(-0.96 -3.71)"
            />
            <path
                fill="#ffffff"
                d="M8.32,8.07H3.11A.13.13,0,0,1,3,7.94a.13.13,0,0,1,.13-.13H8.32a.13.13,0,0,1,.13.13A.13.13,0,0,1,8.32,8.07Z"
                transform="translate(-0.96 -3.71)"
            />
            <path
                fill="#ffffff"
                d="M8.32,9.44H3.11a.13.13,0,1,1,0-.26H8.32a.13.13,0,1,1,0,.26Z"
                transform="translate(-0.96 -3.71)"
            />
            <path
                fill="#ffffff"
                d="M8.32,10.82H3.11a.13.13,0,1,1,0-.26H8.32a.13.13,0,0,1,0,.26Z"
                transform="translate(-0.96 -3.71)"
            />
            <path
                fill="#ffffff"
                d="M8.32,12.2H3.11A.13.13,0,0,1,3,12.06a.13.13,0,0,1,.13-.13H8.32a.13.13,0,0,1,.13.13A.13.13,0,0,1,8.32,12.2Z"
                transform="translate(-0.96 -3.71)"
            />
            <path
                fill="#ffffff"
                d="M8.32,13.56H3.11a.12.12,0,0,1,0-.24H8.32a.12.12,0,0,1,0,.24Z"
                transform="translate(-0.96 -3.71)"
            />
        </svg>
    )
}

export default SmallPostCardIcon
